export default function PhoneVerification() {
  const steps = [
    {
      number: '01',
      icon: 'ri-smartphone-line',
      title: '핸드폰 인증',
      description: '본인 확인을 위한 간단한 인증'
    },
    {
      number: '02',
      icon: 'ri-shield-check-line',
      title: '여성 확인',
      description: '안전한 커뮤니티를 위한 검증'
    },
    {
      number: '03',
      icon: 'ri-check-double-line',
      title: '이용 시작',
      description: '커뮤니티와 공고 모두 확인'
    }
  ];

  return (
    <section id="verification" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-1.5 bg-purple-50 rounded-full">
            <span className="text-sm text-purple-700 font-medium">여성 인증 시스템</span>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            핸드폰 인증으로 여성 확인 완료
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            인증된 회원만 커뮤니티와 공고를 함께 이용할 수 있어요
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="relative group"
            >
              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-100 hover:border-purple-200 hover:shadow-lg transition-all duration-300">
                <div className="flex items-start gap-4 mb-4">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg">
                      <i className={`${step.icon} text-xl text-white`}></i>
                    </div>
                  </div>
                  <div className="text-3xl font-bold text-purple-200">
                    {step.number}
                  </div>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
              
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-2xl text-purple-300"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a 
            href="https://onnyjob.kr/login"
            className="inline-block bg-purple-600 text-white px-8 py-3 rounded-full text-sm font-medium hover:bg-purple-700 transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            인증하고 시작하기
          </a>
        </div>
      </div>
    </section>
  );
}